import React from 'react';
import { connect } from 'react-redux';

import AuthFormDialog from '../AuthFormDialog';
import NotificationsPopup from '../NotificationsPopup';
import ModalDialogs from '../ModalDialogs';


const PopupDialogBox = (props) => (
  <React.Fragment>
    {props.notifications.length > 0 && (
      <NotificationsPopup notifications={props.notifications} />
    )}
    {props.authForm.isActive && (
      <AuthFormDialog />
    )}
    {props.modalDialogs.length > 0 && (
      <ModalDialogs dialogs={props.modalDialogs} />
    )}
  </React.Fragment>
);

export function mapStateToProps(state) {
  return {
    authForm: state.authForm,
    modalDialogs: state.modalDialogs,
    notifications: state.notifications,
  };
}

export default connect(mapStateToProps)(PopupDialogBox);
